<template lang="pug">
    .route-list-selector(v-if="show")
        .route-list-selector-btn-container
            md-button.md-accent.md-dense(v-on:click="cancelSelect") Отмена
        .route-list-selector-container(v-loader-overlay="progress") 
            sort-table(
                ref="table" class="route-selector-table" 
                v-bind:columns="tableColumns" v-model="routeLists"  
                v-on:refresh="getItineraries" v-bind:per-page="count" 
                v-bind:total="amount" table-id="route-selector-table" 
                v-bind:showAddButton="false"
                v-bind:loadOnScroll="false"
                v-bind:pageFromQuery="false"
                v-on:item-click="onItemClick"
                cursor="pointer"
            )
                template(slot="freights" slot-scope="scope")  {{ (scope.item.freights) ? scope.item.freights.length : ((scope.item.freights_ids) ? scope.item.freights_ids.length : 0) }}

                template(slot="forwarder" slot-scope="scope") {{ scope.item.forwarder !== null ? scope.item.forwarder.login : '' }}

                template(slot="from_stock" slot-scope="scope") {{ scope.item.from_stock ? scope.item.from_stock.name : 'Не установлен' }}

                template(slot="to_stock" slot-scope="scope") {{ scope.item.to_stock ? scope.item.to_stock.name : 'Не установлен' }}

                template(slot="date" slot-scope="scope") {{ scope.item.date ? moment(scope.item.date).format('DD.MM.YYYY') : 'Не установленна' }}

                template(slot="weight" slot-scope="scope")
                    span(v-if="scope.item.weight") {{scope.item.weight.toFixed(2)}}
                    span(v-else) Не указан

                template(slot="size" slot-scope="scope")
                    span(v-if="scope.item.size") {{scope.item.size.toFixed(2)}}
                    span(v-else) Не указан

                template(slot="status" slot-scope="scope")
                    div(class="itineraries-status" v-bind:style="('color: ' + scope.item.status.color + ';')")
                        span {{scope.item.status.message}}

                template(slot="actions" slot-scope="scope")
                    md-button.md-icon-button.md-dense.small(@click.stop="onItemClick(scope)"): md-icon add
</template>
<script>
    import moment from "moment";
    import SortTable from "./SortTable";
    import RoutelistValidator from '@/helpers/RoutelistValidator'
    export default {
        name: 'route-list-selector',
        components: {SortTable},
        props: {},
        data() {
            return {
                show: false,
                routeLists: [],
                freightsIds: [],
                count: 50,
                callback: null,
                selectMessage: 'Добавить грузы к маршрутному листу №',
                tableColumns: [
                    { label: 'ID', field: 'id', sortable: true},
                    { label: 'Тип', field: 'type_name', sortable: true},
                    
                    { label: 'Отправление', field: 'from_stock', sortable: true},
                    { label: 'Назначение',  field: 'to_stock',   sortable: true},

                    { label: 'Дата исполнения', field: 'date',   sortable: true},
                    { label: 'Статус',          field: 'status', sortable: true},
                    
                    { label: 'Грузы',       field: 'freights', sortable: false},
                    { label: 'Кол-во мест', field: 'seats',    sortable: true},
                    { label: 'Вес (кг)',    field: 'weight',   sortable: false},
                    { label: 'Объём (м<sup>3</sup>)', field: 'size', sortable: false},
                    
                    { label: '', field: 'actions'}
                ],
            }
        },
        computed: {
            progress() {
                return this.progressObj[this.name];
            },
            progressObj() {
                return this.$store.state.progressObj;
            },
            amount() {
                return this.$store.state.deals.route_lists_amount;
            },
        },
        watch: {},
        methods: {
            async onItemClick(routeList) {
                if (!routeList || !routeList.item) return;
                this.hasFreightsErrors = false;
                this.freightsErrors    = [];
                this.freightsWarnings  = [];
                this.canSave           = true;
                let stock, fromStock = null, toStock = null, errors = [];
                if (routeList.item.stock_id)      stock     = await this.getStock(routeList.item.stock_id);
                if (routeList.item.from_stock_id) fromStock = await this.getStock(routeList.item.from_stock_id);
                if (routeList.item.to_stock_id)   toStock   = await this.getStock(routeList.item.to_stock_id);

                let valid = RoutelistValidator.validate(this.$root, this.freights, routeList.item.type, stock, fromStock, toStock, routeList.item.date);
                
                if (valid && valid.hasFreightsErrors) {
                    this.hasFreightsErrors = valid.hasFreightsErrors;
                    this.freightsErrors    = valid.freightsErrors;
                    this.freightsWarnings  = valid.freightsWarnings;
                    this.canSave           = valid.canSave;

                    this.freights.map(freight => {
                        if (this.freightsErrors[freight.id] && this.freightsErrors[freight.id].length) {
                            let error = '<b>Груз ' + freight.traking_number + '</b>';
                            this.freightsErrors[freight.id].map(item => {
                                error += '<div style="color: red; margin: 0 0 2px 0">' + item + '</div>';
                            });
                            errors.push(error);
                        }
                    });
                }

                if (parseInt(routeList.item.status_id) === 3 || parseInt(routeList.item.status_id) === 5) {//Если статус МЛ "Машина принята" или "Выполнен"
                    errors.unshift('<div style="color: red; margin: 0 0 2px 0">Маршрутный лист недоступен для добавления грузов т.к. имеет статус, запрещающий добавлять грузы.</div>');
                    this.canSave = false;
                }

                if (!this.canSave) {
                    this.$root.$emit('z-alert', 'Произошла ошибка проверки грузов или маршрутного листа: ', errors.join('<hr>'));
                    return;
                }

                if (this.callback) this.callback(routeList.item.id);
                this.show = false;
            },
            cancelSelect() {
                if (this.callback) this.callback(null);
                this.show = false;
            },
            getItineraries(page, count, orderBy, orderType, filter) {
                this.$store.commit('showProgressBar', this.name);
                this.$store.commit('deals/setCurrentItinerariesPage', page);
                let params = {
                    page:       (page)      ? page      : 1,
                    count:      (count)     ? count     : this.count,
                    order_by:   (orderBy)   ? orderBy   : 'id',
                    order_type: (orderType) ? orderType : 'desc',
                    filter:     (filter)    ? filter    : {model: [], relation: []},
                };
                this.$store.dispatch('deals/getRouteLists', params).then(r => {
                    if (r && r.length) this.routeLists = Object.assign([], r);
                }).finally(() => this.$store.commit('hideProgressBar', this.name));
            },
            getFreights(freightsIds) {
                this.$store.commit('showProgressBar', this.name);
                return this.$store.dispatch('deals/getFreightsByIds', {ids: freightsIds}).then(freights => {
                    freights = (freights && freights.data) ? freights.data : []
                    this.freights = Object.assign([], freights);
                }).finally(() => this.$store.commit('hideProgressBar', this.name));
            },
            getStock(id) {
                this.$store.commit('showProgressBar', this.name);
                return this.$store.dispatch('stock/getStock', {id: id}).finally(() => this.$store.commit('hideProgressBar', this.name));
            },
            init() {
                this.$on('select', (freightsIds, callback) => {
                    if (!freightsIds || !freightsIds.length || !callback) return;
                    this.freightsIds = freightsIds;
                    this.callback    = callback;
                    this.show = true;
                    this.getFreights(this.freightsIds);
                });
            }
        },
        created() {
            this.init();
        }
    }
</script>
<style scoped lang="sass">
    .route-list-selector
        position: fixed
        z-index: 20
        background: rgba(0, 0, 0, 0.5)
        width: 100vw
        height: 100vh
        left: 0
        right: 0
        top: 0
        bottom: 0
        display: flex
        align-items: center
        justify-content: center
        flex-direction: column
        .route-list-selector-btn-container
            background: #fff
            width: 80%
            display: flex
            align-items: center
            justify-content: flex-end
        .route-list-selector-container
            background: #fff
            width: 80%
            height: 90%
</style>


// WEBPACK FOOTER //
// RouteListSelector.vue?4321e5b3